<template>
    <div>
        <div class="mt-3">
            <div class="text-secondary">
                <button
                    class="px-2 focus:outline-none border-r border-secondary"
                    :class="{
                        'text-darkGrayishBlue': ordHistWithinDays === 30
                    }"
                    @click="ordHistWithinDays = 30"
                >
                    {{ '最近一個月' }}
                </button>
                <button
                    class="px-2 focus:outline-none "
                    :class="{
                        'text-darkGrayishBlue': ordHistWithinDays === undefined
                    }"
                    @click="ordHistWithinDays = undefined"
                >
                    {{ '全部紀錄' }}
                </button>
            </div>
        </div>

        <div class="my-8 flex justify-center" v-if="loading">
            <spinner />
        </div>

        <div v-else-if="hasOrder" class="content-box-wrapper">
            <div class="text-xl font-bold">{{ $t('rdmGift.history') }}</div>

            <div class="w-full flex flex-col">
                <div
                    v-for="(o, oi) in recordsInPage"
                    :key="oi"
                    class="w-full py-8 border-b border-dotted border-gray-100 flex flex-col sm:flex-row sm:items-center"
                >
                    <div class="w-full sm:w-1/2 md:w-2/5 flex-shrink-0 ">
                        <div class="my-1 font-bold">
                            {{ product(o) ? product(o).prodBrndName : '' }}
                            {{ product(o) ? product(o).prodName : '' }}
                            {{ product(o) ? product(o).prodSizeText : '' }}
                        </div>
                        <div class="my-1">
                            {{ '參考編號' }}
                            :
                            {{ o.saleOrdNum }}
                        </div>
                        <div class="my-1">
                            {{ '換領日期' }}
                            :
                            {{ o.saleOrdCreDate | formatDate('fullDateTime') }}
                        </div>
                        <div class="my-1">
                            {{ '數量' }}
                            :
                            {{ product(o).prodOrdQty }}
                        </div>
                        <div class="my-1">
                            如禮品屬電子換領票，請往
                            <router-link
                                :to="{
                                    name: 'eventTicketHistory'
                                }"
                                class="text-secondary underline"
                            >
                                電子門票
                            </router-link>
                            查看詳情。
                        </div>
                    </div>
                    <div class="flex-grow flex" style="max-width: 200px;">
                        <div class="flex-grow flex flex-col items-stretch">
                            <router-link
                                :to="{
                                    name: 'rdmGiftProduct',
                                    params: { id: product(o).shopListProdKey }
                                }"
                            >
                                <productImage
                                    imageType="small"
                                    :product="product(o)"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex justify-center mt-4">
                <pager
                    class="mx-auto"
                    :page="pager.page"
                    :recordsPerPage="pager.recordsPerPage"
                    :totalRecords="list.length"
                    @setPage="p => (pager.page = p)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import formatDate from '@/components/formatDateFilter';
import productImage from '@/components/productImage.vue';
import pager from '@/components/pager.vue';

export default {
    components: {
        spinner,
        productImage,
        pager
    },
    filters: { formatDate },
    data() {
        return {
            loading: true,
            pager: {
                page: 1,
                recordsPerPage: 10
            },
            ordHistWithinDays: 30
        };
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch('loadOrderList', this.ordHistWithinDays);
        this.loading = false;

        this.$watch('ordHistWithinDays', async function() {
            this.loading = true;
            await this.$store.dispatch('loadOrderList', this.ordHistWithinDays);
            this.loading = false;
        });
    },
    computed: {
        list() {
            return this.$store.state.orderList.filter(
                ord => ord.saleOrdTypeCode === 'RDM'
            );
        },
        recordsInPage() {
            const start = (this.pager.page - 1) * this.pager.recordsPerPage;
            return this.list.slice(start, start + this.pager.recordsPerPage);
        },
        hasOrder() {
            return this.list && this.list.length > 0;
        },
        product() {
            return ord => ord.saleOrdProdList[0];
        }
    }
};
</script>
